import React, { useState } from 'react';
import EnhancedChatBuilder from './components/EnhancedChatBuilder';
import EnhancedInteractiveChatBot from './components/EnhancedInteractiveChatBot';
import ChatbotAnalytics from './components/ChatbotAnalytics';
import ChatbotTest from './components/ChatbotTest';
import ChatbotTemplates from './components/ChatbotTemplates';
import '@xyflow/react/dist/style.css';

export default function ChatBot() {
  const [activeTab, setActiveTab] = useState('test'); // 'test', 'builder', 'interactive', 'analytics', or 'templates'
  const [showTemplates, setShowTemplates] = useState(false);

  const tabStyle = {
    padding: '12px 24px',
    border: 'none',
    background: 'transparent',
    cursor: 'pointer',
    fontSize: '16px',
    fontWeight: '500',
    borderBottom: '3px solid transparent',
    transition: 'all 0.3s ease',
  };

  const activeTabStyle = {
    ...tabStyle,
    borderBottom: '3px solid #25d366',
    color: '#25d366',
  };

  return (
    <div style={{ height: '100vh', display: 'flex', flexDirection: 'column', width: '100%' }}>
      {/* Tab Navigation */}
      <div style={{
        background: '#fff',
        borderBottom: '1px solid #e0e0e0',
        display: 'flex',
        padding: '0 32px',
      }}>
        <button
          style={activeTab === 'test' ? activeTabStyle : tabStyle}
          onClick={() => setActiveTab('test')}
        >
          System Test
        </button>
        <button
          style={activeTab === 'builder' ? activeTabStyle : tabStyle}
          onClick={() => setActiveTab('builder')}
        >
          Flow Builder
        </button>
        <button
          style={activeTab === 'interactive' ? activeTabStyle : tabStyle}
          onClick={() => setActiveTab('interactive')}
        >
          Interactive ChatBot
        </button>
        <button
          style={activeTab === 'analytics' ? activeTabStyle : tabStyle}
          onClick={() => setActiveTab('analytics')}
        >
          Analytics
        </button>
        <button
          style={activeTab === 'templates' ? activeTabStyle : tabStyle}
          onClick={() => setActiveTab('templates')}
        >
          Templates
        </button>
      </div>

      {/* Tab Content */}
      <div style={{ flex: 1, overflow: 'hidden', width: '100%' }}>
        {activeTab === 'test' ? (
          <ChatbotTest />
        ) : activeTab === 'builder' ? (
          <EnhancedChatBuilder />
        ) : activeTab === 'interactive' ? (
          <EnhancedInteractiveChatBot />
        ) : activeTab === 'analytics' ? (
          <ChatbotAnalytics />
        ) : activeTab === 'templates' ? (
          <div style={{ padding: '20px', textAlign: 'center' }}>
            <h2 style={{ color: '#25d366', marginBottom: '20px' }}>🤖 Chatbot Templates</h2>
            <p style={{ marginBottom: '20px', color: '#666' }}>
              Choose from pre-built templates to get started quickly with your chatbot
            </p>
            <button
              onClick={() => setShowTemplates(true)}
              style={{
                padding: '12px 24px',
                background: '#25d366',
                color: 'white',
                border: 'none',
                borderRadius: '8px',
                cursor: 'pointer',
                fontSize: '16px',
                fontWeight: '500'
              }}
            >
              Browse Templates
            </button>
          </div>
        ) : null}
      </div>

      {/* Templates Modal */}
      {showTemplates && (
        <ChatbotTemplates
          onTemplateSelect={(template) => {
            console.log('Template selected:', template);
            setShowTemplates(false);
          }}
          onClose={() => setShowTemplates(false)}
        />
      )}
    </div>
  );
}
